import React from "react";

export const LazyMicrosoftTeamsCallPaletteInsertBridge = React.lazy(
    () => import(/* webpackChunkName: "MSTeams" */ "./PaletteInsert")
);
